import React from 'react';
import PropTypes from 'prop-types';
import { Paper, makeStyles } from '@material-ui/core';
import CircularProgress from 'components/shared/CircularProgress';
import AddReviewForm from './AddReviewForm';

const styles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
}));

const ReviewEdit = ({ initialValues, sendReview, isLoading, isUpdating }) => {
  const classes = styles();

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Paper className={classes.paper}>
      <AddReviewForm
        initialValues={initialValues}
        isUpdating={isUpdating}
        sendReview={sendReview}
      />
    </Paper>
  );
};

ReviewEdit.propTypes = {
  isLoading: PropTypes.bool,
  isUpdating: PropTypes.bool,
  initialValues: PropTypes.shape({}),
  sendReview: PropTypes.func.isRequired,
};

export default ReviewEdit;
